import { SxProps, Theme } from "@mui/material";

export const assessmentMobileTopInset = "calc(env(safe-area-inset-top, 0px) + 32px)";

// Phone on its side: width can exceed `sm`, height is limited — keep compact spacing.
export const assessmentPhoneLandscapeQuery =
  "(orientation: landscape) and (max-width: 900px)";
export const assessmentPhoneLandscapeMedia = `@media ${assessmentPhoneLandscapeQuery}`;

export const assessmentTabletLandscapeQuery =
  "(orientation: landscape) and (min-width: 900px) and (max-width: 1200px)";
export const assessmentTabletLandscapeMedia = `@media ${assessmentTabletLandscapeQuery}`;

// Short portrait phones / constrained emulator heights (e.g. 320x480).
export const assessmentShortViewportQuery = "(max-height: 600px)";
export const assessmentShortViewportMedia = `@media ${assessmentShortViewportQuery}`;

const assessmentFullscreenShellSx = {
  position: "relative" as const,
  top: 0,
  left: 0,
  transform: "none",
  width: "100%",
  height: "100%",
  maxHeight: "100dvh",
  borderRadius: 0,
  boxShadow: "none",
  pt: "max(env(safe-area-inset-top, 0px), 8px)",
  pb: "env(safe-area-inset-bottom, 0px)",
};

// Outer wrapper — fullscreen on every viewport (same as mobile).
export const assessmentPopUpOuterStyle: SxProps<Theme> = {
  position: "fixed",
  top: 0,
  left: 0,
  transform: "none",
  width: "100vw",
  height: "100dvh",
  maxHeight: "100dvh",
  zIndex: 99,
  p: 0,
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
};

// Modal shell — fills the viewport; no card chrome.
export const assessmentPopUpShellStyle: SxProps<Theme> = (theme) => ({
  position: "relative",
  top: 0,
  left: 0,
  transform: "none",
  width: "100%",
  height: "100%",
  maxHeight: "100dvh",
  minHeight: 0,
  borderRadius: 0,
  boxShadow: "none",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  flex: "1 1 auto",
  minWidth: 0,
  pt: assessmentMobileTopInset,
  pb: "env(safe-area-inset-bottom, 0px)",
  backgroundColor: theme.palette.quizPopap.quizBg,
  color: theme.palette.quizPopap.quizText,
  [assessmentShortViewportMedia]: {
    pt: "max(env(safe-area-inset-top, 0px), 4px)",
  },
  [assessmentPhoneLandscapeMedia]: {
    ...assessmentFullscreenShellSx,
    backgroundColor: theme.palette.quizPopap.quizBg,
    color: theme.palette.quizPopap.quizText,
  },
});

export const assessmentOverlayCardStyle: SxProps<Theme> = {
  position: "relative",
  top: 0,
  left: 0,
  transform: "none",
  width: "100%",
  height: "100%",
  maxHeight: "100dvh",
  borderRadius: 0,
  boxShadow: "none",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  pt: assessmentMobileTopInset,
  pb: "env(safe-area-inset-bottom, 0px)",
  [assessmentPhoneLandscapeMedia]: assessmentFullscreenShellSx,
};

// Inner screen content — fills shell; scroll in child regions.
export const assessmentFlowContainerStyle: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  flex: "1 1 auto",
  minHeight: 0,
  height: "100%",
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
  color: theme.palette.quizPopap.quizText,
});
